<template>
    <a-tabs
        default-active-key="1"
        tab-position="top"
        type="card"
        :tabBarStyle="tabBarStyle"
    >
        <a-tab-pane key="1" tab="Inscrição">
            <PropertyDetails v-if="propertyDetail" :data="propertyDetail"/>
        </a-tab-pane>

        <a-tab-pane key="2" tab="Edificações">
           <Buildings v-if="dataBuildings" :data="dataBuildings"/>
        </a-tab-pane>

        <a-tab-pane key="3" tab="Proprietários">
            <Owners v-if="dataOtherOwners" :data="dataOtherOwners"/>
        </a-tab-pane>

<!--        <a-tab-pane key="4" tab="Cálculo">-->
<!--            <Calculation />-->
<!--        </a-tab-pane>-->

        <a-tab-pane key="4">
            <template #tab>
                <p style="text-align:center; margin-bottom:0">Documentos<br>Inscrição</p>
            </template>

            <Files :data="files" :property-id="props.data.id"></Files>
        </a-tab-pane>

        <a-tab-pane key="5">
            <template #tab>
                <p style="text-align:center; margin-bottom:0">Documentos<br>Lote</p>
            </template>

            <SubdivisionFiles :subdivision-property-id="props.subdivisionPropertyId" />
        </a-tab-pane>

        <a-tab-pane key="6">
            <template #tab>
                <p style="text-align:center; margin-bottom:0">Observações<br>Geo</p>
            </template>

            <div style="display:flex; flex-direction:column; align-items:end; padding: 0 10px">
                <a-textarea v-model:value="newObs" :rows="10" allow-clear :auto-size="{ minRows: 10, maxRows: 10 }"
                            :readonly="!editingObs" :class="{ 'readonly-cursor': !editingObs }" />

                <div style="display:flex; margin-top:10px; gap:10px">
                    <a-button v-if="editingObs" type="text" size="large" v-text="'Cancelar'" :disabled="loading"
                              @click="() => { editingObs = false; newObs = oldObs }" />
                    <a-button :type="editingObs ? 'primary' : 'default'" size="large" :loading="loading" :disabled="!geoPermission"
                              @click="handleObs()">
                        {{ editingObs ? 'Atualizar' : 'Editar' }}
                    </a-button>
                </div>
            </div>
        </a-tab-pane>

        <a-tab-pane key="7">
            <template #tab>
                <p style="text-align:center; margin-bottom:0">Valor Venal</p>
            </template>

            <AssessedValue :property-id="props.data.id" />
        </a-tab-pane>

        <a-tab-pane key="8" v-if="hasPlantInfo">
            <template #tab>
                <p style="text-align:center; margin-bottom:0">Informações<br />Planta</p>
            </template>

            <Plants :loteData="loteData" :constructionsData="constructionsData" :property-id="props.data.id" />
        </a-tab-pane>
    </a-tabs>
</template>

<script setup>

import {defineProps, onMounted, ref} from "vue";
import PropertyDetails from "./Tabs/PropertyDetails.vue";
import Buildings from "./Tabs/Buildings.vue";
import Owners from "./Tabs/Owners.vue";
import Files from "./Tabs/Files.vue";
import SubdivisionFiles from "./Tabs/SubdivisionFiles.vue";
import {notification} from "ant-design-vue";
import verifySpecificFuncPermissions from "../../../../../utils/verifySpecificFuncPermissions";
import AssessedValue from "./Tabs/AssessedValue.vue";
import Plants from "./Tabs/Plants.vue";
import { openNotification } from "../../../../../utils/utilities.js";

const props = defineProps({
    data:  [Object],
    subdivisionPropertyId: Number,
})
const geoPermission = ref(false)
const editingObs = ref(false)
const loading = ref(false)
const hasPlantInfo = ref(false)
const loteData = ref({})
const constructionsData = ref([])
const oldObs = ref('')
const newObs = ref('')
const handleObs = async () => {
    (editingObs.value)
        ? await saveGeoObs()
        : editingObs.value = true
}

const saveGeoObs = async () => {
    loading.value = true

    const formData = new FormData()
    formData.append('obs', newObs.value)
    formData.append('_method', 'PUT');

    try {
        await window.axios.post(`/api/map-actions/bic/${props.subdivisionPropertyId}/save-subdivision-obs`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        openNotification('success', 'Observação atualizada com sucesso!')
        oldObs.value = newObs.value
        editingObs.value = false
    } catch (error) {
        openNotification('error', 'Houve algum erro ao atualizar a observação.')
    }

    loading.value = false
}

const { buildings, otherOwners, ...details} = props.data
const propertyDetail = ref({
    ...details,
    promiser: otherOwners.find((owner) => owner.isPromising === true && owner.order === "Primário"),
    subdivisionId: props.subdivisionPropertyId,
})

const dataBuildings = ref({
    fatherId: props.data.id,
    subdivision: props.data.subdivision,
    block: props.data.block,
    sector: props.data.sector,
    buildings: buildings
})

const files = ref({
    images: props.data.attachments.filter(f => f.type === 1),
    planta: props.data.attachments.filter(f => f.type === 2),
    croqui: props.data.attachments.filter(f => f.type === 3),
    buySell: props.data.attachments.filter(f => f.type === 4)
})

const dataOtherOwners = ref(otherOwners)

const tabBarStyle = {
    fontSize: '10px',
    padding: '0 6px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
};

onMounted(async () => {
    oldObs.value = (await window.axios.get(`/api/map-actions/bic/${props.subdivisionPropertyId}/get-subdivision-obs`)).data.data
    newObs.value = oldObs.value

    loteData.value = (await window.axios.get('/api/map-actions/bic/' + props.subdivisionPropertyId + '/lot')).data.data;
    constructionsData.value = (await window.axios.get('/api/map-actions/bic/' + props.subdivisionPropertyId + '/constructions')).data.data;
    hasPlantInfo.value = loteData.value || constructionsData.value

    geoPermission.value = await verifySpecificFuncPermissions(2)
})
</script>

<style scoped>
.inner-tabs {
    max-width: 100%;
    margin-top: 16px;
}

.inner-tabs .ant-tabs-tab {
    font-size: 12px;
    padding: 8px 16px;
}

.inner-tabs .ant-tabs-tabpane {
    padding: 8px;
}

::v-deep(.readonly-cursor.ant-input) {
    cursor: copy !important;
}
</style>